import { gql } from '@apollo/client';

export const getAdminReviews = gql`
    query getAdminReviews {
        getAdminReviews {
            id
            listId
            listData {
            id
            title
            }
            authorId
            reviewContent
            rating
            createdAt
            updatedAt
        }
    }
    `;

export const deleteAdminReview = gql`
    mutation deleteAdminReview ($reviewId: Int!) {
        deleteAdminReview (reviewId: $reviewId) {
          status
        }
      }
    `;

export const updateReview = gql`
    mutation updateReview($id: Int, $type: String){
        updateReview(id: $id, type: $type) {
          status
        }
      }
    `;

export const getReviewsDetails = gql`
query getReviewsDetails($currentPage: Int, $searchList: String){
      getReviewsDetails(currentPage: $currentPage, searchList: $searchList) {
        status
        count
        results{
          id
          reservationId
          listId
          authorId
          userId
          reviewContent
          rating
          privateFeedback
          parentId
          automated
          isAdmin
          createdAt
          updatedAt
          isAdminEnable
          authorData {
            userId
            firstName
            profileId
          }
          userData{
            userId
            profileId
            firstName
          }
          listData {
            id
            title
          }
        singleReservationData{
          id
          checkIn
          checkOut
          confirmationCode
        }
      }
      }
  }`;